import { TLanguage } from "../common/other";

export const LANGUAGES: { [key in TLanguage]: TLanguage } = {
  en: "en",
  vn: "vn",
};
